import React from 'react'
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import HandshakeIcon from '@mui/icons-material/Handshake';
import StarsIcon from '@mui/icons-material/Stars';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonPinIcon from '@mui/icons-material/PersonPin';

export default function StatsSection() {
     const { ref, inView } = useInView({
    triggerOnce: true,
  });

  const stats = [
    { value: 50, suffix: "+ Crore ", label: "Loans Processed", icon: <CurrencyRupeeIcon/> },
    { value: 1000000, suffix: "+", label: "Customers Served", icon: <ManageAccountsIcon/>  },
    { value: 20, suffix: "+", label: "Serving City", icon: <PersonPinIcon/>  },
    { value: 4, suffix: "+", label: "Google Review", icon: <StarsIcon/>  },
  ];
  return (
    
      <section className="bg-[#072c4c] pb-10">
      <div
        ref={ref}
        className="max-w-7xl mx-auto px-4 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6  text-white"
      >
        {stats.map((item, index) => (
          <div key={index} className="flex items-center gap-5">

            {/* Icon Box */}
            <div className="ms-bg-secondary p-2 rounded-[50px]"> <span>{item.icon}</span></div>

            {/* Counter */}
            <div className='flex-col'>
            <h2 className="text-3xl sm:text-3xl font-semibold">
              {inView && (
                <CountUp
                  start={0}
                  end={item.value}
                  duration={2}
                />
              )} 
              {item.suffix}
            </h2>

            {/* Label */}
            <p className="text-sm text-gray-300">{item.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
    
  )
}
